export enum InputTypes {
    String = 'String',
    Text = 'Text',
    Mail = 'Mail',
    Phone = 'Phone',
    Select = 'Select',
    File = 'File',
    Name = 'Name',
    Surname = 'Surname',
    Multiple = 'Multiple',
    Telegram = 'Telegram',
    Additionalmail = 'Additionalmail'
}export enum InputTypes {
    String = 'String',
    Text = 'Text',
    Mail = 'Mail',
    Phone = 'Phone',
    Select = 'Select',
    File = 'File',
    Name = 'Name',
    Surname = 'Surname',
    Multiple = 'Multiple',
    Telegram = 'Telegram',
    Additionalmail = 'Additionalmail'
}